import { QueryClient } from '@tanstack/react-query';

export const appQueryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnMount: true,
            retry: 0,
            staleTime: 1000 * 60,
        },
    },
});
